import { api } from './client';

// Activity Feed API
export const activityFeedApi = {
  getAll: (params?: { page?: number; limit?: number; entity_type?: string }) =>
    api.get<{
      activities: import('../types').ActivityFeedItem[];
      pagination: import('../types').PaginationInfo;
    }>('/activity-feed', params),
};
